import { getSearchFilters } from "@/src/actions/flightAction";
import {
  getAirportCity,
  getFullAirportDetail,
  getAirportInfo,
} from "@/src/helpers/getAirportCity";
import moment from "moment";
import { useEffect, useState } from "react";
import { FaCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";

export default function DomesticFlightItem({
  fd,
  type,
  isLastIndex,
  isFirstIndex,
}) {
  const {
    searchFilters,
    flightSearchForm,
    searchForm,
  } = useSelector((state) => state.flights);
  const dispatch = useDispatch();
  const isDeparture = type == "departure";
  const { Airports } = searchFilters;
  useEffect(() => {
    if (Airports == null) {
      dispatch(getSearchFilters());
      // navigate('/flights')
    }
  }, []);

  return (
    Airports && (
      <div className="grid grid-cols-10 px:2 lg:px-4 justify-center items-center">
        <div className="col-span-2 py-4 text-right">
          <h1 className="text-base lg:text-lg font-medium">
            {/* {isDeparture ? fd.DepartureDate : fd.ArrivalDate} */}
            {moment(isDeparture ? fd.DepartureDate : fd.ArrivalDate).format(
              "ll"
            )}
          </h1>
          <p className="text-destructive text-xs lg:text-sm">
            {/* {moment(fd.DepartureTime).format("ll")} */}
            {isDeparture ? fd.DepartureTime : fd.ArrivalTime}
          </p>
        </div>
        <div className="col-span-1 flex flex-col justify-between h-full items-center px-5">
          {isDeparture ? (
            <>
              {isFirstIndex ? (
                <span className="flex-1 w-1 h-full ml-1"></span>
              ) : (
                <span className="flex-1 w-1 h-full border-l border-dotted border-gray-300 ml-1"></span>
              )}
              <span className="text-gray-300">
                <span className="text-gray-300">
                  <FaCircle className="w-2 h-2" />
                </span>
              </span>
              <span className="flex-1 w-1 h-full border-l border-gray-300 ml-1"></span>
            </>
          ) : (
            <>
              <span className="flex-1 w-1 h-full border-l  border-gray-300 ml-1"></span>
              <span className="text-gray-300">
                <FaCircle className="w-2 h-2" />
              </span>
              {isLastIndex ? (
                <span className="flex-1 w-1 h-full "></span>
              ) : (
                <span className="flex-1 w-1 h-full border-l border-dotted border-gray-300 ml-1"></span>
              )}
            </>
          )}
        </div>
        <div className="col-span-7 flex-1 py-3 px-2">
          <div>
            {(() => {
              const code = isDeparture ? fd.Origin : fd.Destination;
              const airport = getAirportInfo(code, Airports);
              return (
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center min-w-12 h-8 bg-slate-500 text-white rounded font-bold text-sm px-1">
                    {code}
                  </div>
                  <div className="flex flex-col leading-tight">
                    <span className="font-bold text-sm">
                      {airport?.AirportCity || ""}, {airport?.Country || ""}
                    </span>
                    <span className="text-[13px] text-muted-foreground">
                      {airport?.AirportName || ""}
                    </span>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      </div>
    )
  );
}
